import React from 'react'

export function PlaylistsLanding() {
  return (
    <div className="playlists-landing-jumbo">

    </div>
  )
}
